
import Vue from "vue";

export default Vue.extend({
  name: "Checkout",
  data: () => ({
    //
  }),
  components: {
    //AppBar,
    // AppFooter,
  },
  mounted() {
    //this.loadingComponentOverlay = false;
  },
});
